// @ts-nocheck

import * as R from 'ramda';
import MarketingActions from '../actions/MarketingActions';
import MainDispatcher from '../support/MainDispatcher';
import AppsStore from './AppsStore_LEGACY';
import store from './Store';

var PRESET_FIELDS = [
  '~campaign',
  '~channel',
  '~creation_source',
  '~feature',
  '~id',
  '~marketing',
  '~stage',
  '~tags',
  '$android_url',
  '$blackberry_url',
  '$desktop_deepview',
  '$desktop_url',
  '$fire_url',
  '$identity_id',
  '$ios_url',
  '$marketing_title',
  '$og_description',
  '$og_image_url',
  '$og_title',
  '$one_time_use',
  '$windows_phone_url',
];

var _loading = false;
var _newLink = { id: 'new', data: {} };
var _links = null;
var _initLinksLoaded = false;
var _loadingMore = false;
var _linksCached = null;
var _filters = null;
var _stats = {};
var _archived = false;
var _selectedComparator = 'date';
var _isReversed = false;
var _selectedFilters = {};
var _showWebSession = false;
var _searchString = null;

function getMetric(link) {
  if (!link || !_stats[link.id]) {
    return 0;
  }
  return _stats[link.id][_selectedComparator] || 0;
}

function hasWebSessionData(stats) {
  var found = false;
  for (var i in stats) {
    if (stats.hasOwnProperty(i) && stats[i] && stats[i].session) {
      found = true;
      break;
    }
  }
  return found;
}
// Check to the see if the link props match ALL the selected filters
function matchWithFilters(filters, link) {
  return R.reduceObj(
    (acc, values, key) => {
      if (!acc) {
        return acc;
      }
      var field = link[key];
      return R.reduce(
        (acc, value) => {
          if (!acc) {
            return acc;
          }
          if (field instanceof Array) {
            return R.contains(value, field);
          }
          return value === field;
        },
        true,
        values
      );
    },
    true,
    filters
  );
}

function linkFilter(link) {
  link.archived = !!link.archived; // coerce null values to false
  // Filtering - archived
  if (link.archived !== _archived) {
    return false;
  }
  // Filtering - search
  if (_searchString) {
    const trimmedSearchString = _searchString.toLowerCase().trim();
    if (
      (link.data.$marketing_title + '' || '').toLowerCase().indexOf(trimmedSearchString) === -1 &&
      (link.url || '').toLowerCase().indexOf(trimmedSearchString) === -1
    ) {
      return false;
    }
  }
  // Filtering - selected
  if (R.flatten(R.values(_selectedFilters)).length) {
    return matchWithFilters(_selectedFilters, link);
  }
  return true;
}

var COMPARATORS = {
  name: function (link) {
    return (link.data.$marketing_title + '' || '').toLocaleLowerCase();
  },
  url: function (link) {
    return link.url.toLowerCase();
  },
  click: getMetric,
  install: getMetric,
  commerce: getMetric,
  revenue: getMetric,
  open: getMetric,
  event: getMetric,
  session: getMetric,
  date: function () {
    throw 'date is a server side sorting operation';
  },
};

var MarketingStore = store({
  getLinks: function () {
    if (!_linksCached || !_initLinksLoaded) {
      if (!_loading) {
        _loading = true;
        setTimeout(function () {
          MarketingActions.load();
        }, 0);
      }
      return [];
    }
    return _linksCached;
  },
  getProcessedLinks: function () {
    var links = MarketingStore.getLinks();
    links = R.pipe(
      R.uniqWith((a, b) => a.id === b.id),
      R.filter(linkFilter)
    )(links);
    // Sorting
    if (COMPARATORS[_selectedComparator]) {
      if (_selectedComparator !== 'date') {
        links = R.sortBy(COMPARATORS[_selectedComparator], links);
      }
      // Reverse sorting
      if (_isReversed) {
        links = R.reverse(links);
      }
    }
    return links;
  },
  getLink: function (action, id) {
    // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
    if (action == 'new') {
      return _newLink;
    }
    return R.find(function (link) {
      // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
      return link.id == id;
    }, _linksCached || []);
  },
  getFilters: function () {
    return _filters || {};
  },
  getPresetFields: function () {
    return PRESET_FIELDS;
  },
  getAliasList: function () {
    return R.map(function (link) {
      return link.alias;
    }, this.getLinks());
  },
  loaded: function () {
    return !_loading;
  },
  loadingMore: function () {
    return _loadingMore;
  },
  isArchived: function () {
    return _archived;
  },
  getSelectedComparator: function () {
    return _selectedComparator;
  },
  getIsReversed: function () {
    return _isReversed;
  },
  _addFilter: function (key, value) {
    var new_set = [];
    if (_selectedFilters[key]) {
      new_set = _selectedFilters[key];
    }
    new_set.push(value);

    _selectedFilters[key] = new_set;
  },
  _removeFilter: function (key, value) {
    _selectedFilters[key] = R.filter((val) => {
      // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
      return val != value;
    }, _selectedFilters[key]);
  },
  _removeAllFilters: function () {
    _selectedFilters = {};
  },
  getSelectedFilters: function () {
    return _selectedFilters;
  },
  getSearchString: function () {
    return _searchString;
  },
  showWebSession: function () {
    return _showWebSession;
  },
});

function computeFilters() {
  return R.reduce(
    function (acc, filter_name) {
      var linkReducer = R.filter(function (link) {
        if (link[filter_name] && link[filter_name].length > 0) {
          return true;
        }
        return false;
      });
      var linkMapper = R.map(function (link) {
        return link[filter_name];
      });
      var values = R.pipe(linkReducer, linkMapper, R.flatten, R.uniq);

      return R.assoc(filter_name, values(_linksCached), acc);
    },
    {},
    ['campaign', 'channel', 'feature', 'tags']
  );
}

function checkSelectedFilters() {
  // Ensure that all selected filters actually have a matching filter
  return R.omit(function (selected) {
    return R.any(function (filter) {
      return selected.filter === filter.name && R.indexOf(selected.value, filter.values) !== -1;
    }, _filters);
  }, _selectedFilters);
}

function computeLinks() {
  if (!_links) {
    return;
  }

  // Clone...
  _linksCached = R.map(function (link) {
    return R.merge(link, { data: R.merge({}, link.data) });
  }, _links);
  _filters = computeFilters();
  _selectedFilters = checkSelectedFilters();
  MarketingStore.emitChange();
}

MarketingStore.dispatchToken = MainDispatcher.register(function (action) {
  MainDispatcher.waitFor([AppsStore.dispatchToken]);
  switch (action.action) {
    case 'APP_CHANGE':
      _links = _loading = _linksCached = null;
      _showWebSession = false;
      MarketingStore.getLinks();
      MarketingStore.emitChange();
      break;

    case 'ENTITY_SAVED':
      // Settings may have loaded/changed, recompute urls.
      computeLinks();
      break;

    case 'MARKETING_LOADING':
      MarketingStore.emitChange();
      break;

    case 'MARKETING_LOADED':
      // Set links and custom fields.
      _links = action.links;
      _initLinksLoaded = true;
      _loading = false;
      computeLinks();
      MarketingStore.emitChange();
      break;

    case 'MARKETING_BULK_SAVING':
    case 'MARKETING_SAVING':
      _links = R.map((linkObj) => {
        linkObj.newLink = false;
        return linkObj;
      }, _links);
      break;

    case 'MARKETING_SAVED':
      action.link.archived = false;
      action.link.newLink = true;
      if (!_links) {
        // if create link without loading list first
        return;
      }
      var idx = R.findIndex(function findLink(link) {
        return link.id === action.link.id;
      }, _links);

      if (idx !== -1) {
        _links[idx] = action.link;
      } else {
        _links.unshift(action.link);
      }
      _filters = null;
      computeLinks();
      break;

    case 'MARKETING_UPDATE':
      // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
      if (action.link.id == 'new') {
        _newLink = action.link;
      } else {
        _links[
          R.findIndex(function (link) {
            // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
            return link.id == action.link.id;
          }, _links)
        ] = action.link;
      }
      _filters = null;
      computeLinks();
      MarketingStore.emitChange();
      break;

    case 'MARKETING_DELETE':
      _links.splice(
        R.findIndex(function (link) {
          return link.id === action.link_id;
        }, _links),
        1
      );
      computeLinks();
      MarketingStore.emitChange();
      break;

    case 'MARKETING_BULK_SAVED':
      action.links = R.map(function (linkObj) {
        linkObj.archived = false;
        linkObj.newLink = true;
        _links.unshift(linkObj);
        return linkObj;
      }, action.links);
      _filters = null;
      computeLinks();
      break;

    case 'MARKETING_CANCEL':
      computeLinks();
      break;

    case 'MARKETING_TOGGLE_ARCHIVED':
      _archived = !_archived;
      MarketingStore.emitChange();
      break;

    case 'MARKETING_ARCHIVED':
      _links[
        R.findIndex(function (link) {
          // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
          return link.id == action.link_id;
        }, _links)
      ].archived = !action.archived;
      computeLinks();
      MarketingStore.emitChange();
      break;

    case 'MARKETING_SET_FILTER':
      _filters = action.filter;
      MarketingStore.emitChange();
      break;

    case 'MARKETING_SET_REVERSED_ORDER':
      _isReversed = action.isReversed;
      MarketingStore.emitChange();
      break;

    case 'MARKETING_SET_COMPARATOR':
      _selectedComparator = action.comparator;
      MarketingStore.emitChange();
      break;

    case 'MARKETING_ADD_FILTER':
      MarketingStore._addFilter(action.key, action.value);
      MarketingStore.emitChange();
      break;

    case 'MARKETING_REMOVE_FILTER':
      MarketingStore._removeFilter(action.key, action.value);
      MarketingStore.emitChange();
      break;

    case 'MARKETING_REMOVE_ALL_FILTERS':
      MarketingStore._removeAllFilters();
      MarketingStore.emitChange();
      break;

    case 'MARKETING_SET_SELECTED_FILTERS':
      _selectedFilters = action.filters;
      MarketingStore.emitChange();
      break;

    case 'MARKETING_SET_SEARCH_STRING':
      _searchString = action.searchString;
      MarketingStore.emitChange();
      break;
    case 'MARKETING_SET_STATS':
      _stats = action.stats || {};
      _showWebSession = _showWebSession || hasWebSessionData(_stats);
      MarketingStore.emitChange();
      break;
    case 'MARKETING_MORE_LOADING':
      _loadingMore = true;
      MarketingStore.emitChange();
      break;
    case 'MARKETING_MORE_LOADED':
      _loadingMore = false;
      _links = _links.concat(action.links);
      computeLinks();
      MarketingStore.emitChange();
      break;
    case 'MARKETING_SINGLE_LINK_LOADED':
      _links = _links && action.link ? _links.concat(action.link) : [action.link];
      computeLinks();
      MarketingStore.emitChange();
      break;
  }
});

export default MarketingStore;
